<template>
    <div>
        <v-dialog
            v-model="dialog"
            max-width="800"
            @click:outside="closeDialog"
            >
            <v-card>
                <v-card-title class="text-h5" :style="{'color': theme}">
                {{title}}
                <hr style="width:100%; border:solid; border-color:rgba(0, 0, 0, 0.12); border-width:thin 0 0 0;"/>
                </v-card-title>
                
                <v-card-text>                    
                    <v-row v-if="filterItems" justify="end" align="center">
                      <v-col cols="12" sm="12" md="4" lg="4">
                        <div style="padding:10px 10px 0px 10px;">
                         <v-autocomplete
                            v-model="selectedCampaignFilter"
                            item-value="id" 
                            item-text="name"
                            :items="filterCampaigns"
                            label="Campaign Filter"
                            dense
                            hide-details
                            outlined
                            attach
                            @change="selectedChangeHandler"
                          ></v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4">
                        <div style="padding:10px 10px 0px 10px;">
                          <v-select
                            v-model="selectedFilter"
                            item-value="id" 
                            item-text="name"
                            :items="filterItems"
                            label="Filter"
                            dense
                            hide-details
                            outlined
                            attach
                            @change="selectedChangeHandler"
                          ></v-select>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                            :headers="DataTableHeaders"
                            :items="DataItems"
                            :items-per-page="5"
                            class="elevation-1"
                            :key="dataTableKey"
                        >
                          <template v-slot:[`item.totalPayouts`]="{ item }">
                            {{item.totalPayouts}}/{{item.totalPosts}}
                          </template>
                          <template v-slot:[`item.yetToPayouts`]="{ item }">
                            {{item.yetToPayouts}}/{{item.totalPosts}}
                          </template>
                        </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                          <div v-for="(item, index) in avgArray" :key="index">
                            <div id="avgTitle">{{item.title}}: <span id="avg"> {{item.avg}}</span></div>
                          </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="type === 'duration'">
                      <v-col cols="12">
                          <div >
                            <div class="teamTitle">Team</div>
                            <v-row>
                              <v-col cols="12" sm="12" md="2" lg="2" align="center">
                                <div class="teamSubTitle">Activation: {{total.activation}}</div>
                              </v-col>
                              <v-col cols="12" sm="12" md="2" lg="2" align="center">
                                <div class="teamSubTitle">Pairing: {{total.pairing}}</div>
                              </v-col>
                              <v-col cols="12" sm="12" md="3" lg="3" align="center">
                                <div class="teamSubTitle">CO-Creating: {{total.creating}}</div>
                              </v-col>
                              <v-col cols="12" sm="12" md="2" lg="2" align="center">
                                <div class="teamSubTitle">Completion: {{total.complete}}</div>
                              </v-col>
                              <v-col cols="12" sm="12" md="3" lg="3" align="center">
                                <div class="teamSubTitle">Overall Average: {{total.overall}}</div>
                              </v-col>
                            </v-row>
                          </div>
                      </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    :color="theme"
                    style="color:white;"
                    @click="closeDialog"
                    large
                >
                    OK
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
  name: 'seeMoreModal',
  props: ['dialog', 'title', 'theme', 'headers', 'avgArray', 'DataItems', 'total', 'filterSelected', 'filterItems', 'filterCampaigns', 'type', 'closeDialog'],
  data () {
    return {
      DataTableHeaders: [],
      itemArray: [],
      averageArrayItems: [],
      selectedFilter: '',
      selectedCampaignFilter: '',
      dataTableKey: 0
    }
  },
  mounted() {
    this.generateHeaders(this.headers)
  },
  methods: {
    generateHeaders (headers) {
      let itemVlaue;
      headers.map((item, index) => {
        if (Array.isArray(item.name)) {
          itemVlaue = item.name[0]
        } else {
          itemVlaue = item.name
        }
        if (index === 0) {
          this.DataTableHeaders.push(
            {
              text: item.header,
              value: itemVlaue
            }
          )
        } else {
          this.DataTableHeaders.push(
            {
              text: item.header,
              value: itemVlaue,
              align: 'center'
            }
          )
        }
      })
    },
    selectedChangeHandler() {
      let filter = Object.assign({}, {
        CO: this.selectedFilter,
        Campaign: this.selectedCampaignFilter
      })
      this.$emit('searchFilter', {filter, type: this.type, filterSource: 'detail'})
    }
  }
}
</script>
<style scoped>
  #avgTitle {
    height: 44px;
    left: 50px;
    top: 394px;

    font-family: WorkSans-Regular;
    
    font-size: 24px;
    line-height: 28px;

    color: #000000;
  }

  #avg {
    margin-left:5px;
    font-family: WorkSans-Medium;
    font-size: 24px;

    color: #000000;
  }

  .teamTitle {
    height: 44px;
    left: 50px;
    top: 394px;

    font-family: WorkSans-Regular;
    
    font-size: 24px;
    line-height: 28px;

    color: #000000;
  }

  .teamSubTitle {
    font-family: WorkSans-Regular;
    
    font-size: 14px;
    line-height: 28px;

    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// SeeMoreModal.vue?15adffd8